import React from 'react';
import { ITask } from '../Interfaces/ITask';
import { Chip } from '@mui/material';

interface IProps {
  task: ITask;
}
export const getDeadlineColor = (task: ITask) => {
  const normalize = (d: Date) => new Date(d.setHours(0, 0, 0, 0));
  const deadlineDate = normalize(new Date(task.Deadline_at));
  const toDayDate = normalize(new Date());
  if (task.Closed_at !== null) return 'default.main';
  if (deadlineDate.getTime() === toDayDate.getTime()) return 'warning.main';
  if (deadlineDate > toDayDate) return 'success.main';
  return 'error.main';
};

export const TaskDeadlineChip: React.FC<IProps> = ({ task }) => {
  return (
    <Chip
      size='small'
      variant='outlined'
      label={new Date(task.Deadline_at).toLocaleDateString()}
      sx={{
        borderColor: getDeadlineColor(task),
        color: getDeadlineColor(task),
      }}
    />
  );
};
